
import { Link } from "react-router-dom";
import { FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaTwitter, FaYoutube } from "react-icons/fa";

const Footer = () => {
  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Industries", path: "/industries" },
    { name: "Process", path: "/process" },
    { name: "About Us", path: "/about" },
    { name: "Contact", path: "/contact" }
    
    
  ];

  const services = [
    { name: "AI Consultation Advisory", path: "/service/ai-consultation-advisory" },
    { name: "Digital Transformation", path: "/service/ai-automation-digital-transformation" },
    { name: "Data Intelligence Analytics", path: "/service/data-intelligence-analytics-platform" }
  ];

  const socialMedia = [
    { Icon: FaLinkedinIn, href: "https://www.linkedin.com/in/vicon-ai-8831303a5/", label: "LinkedIn" },
    { Icon: FaTwitter, href: "https://x.com/vicon_ai", label: "Twitter" },
    { Icon: FaFacebookF, href: "https://www.facebook.com/profile.php?id=61584048691779", label: "Facebook" },
    
    { Icon: FaInstagram, href: "https://www.instagram.com/viconai/", label: "Instagram" },
    
    { Icon: FaYoutube, href: "https://www.youtube.com/@ViconAI", label: "YouTube" },
  ];

  return (
    <footer className="bg-[#17091a] text-[#ffffff] relative overflow-hidden rounded-t-[3rem]">
      {/* Background Ambient Glow */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#952877]/10 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-8">
              <div className="w-12 h-12 bg-[#ffffff] rounded-xl flex items-center justify-center shadow-lg group cursor-pointer transition-transform duration-300 hover:scale-110">
                <img className='w-full h-full object-contain overflow-hidden rounded-xl' src="/images/Logo12png.png" alt="logo" />
              </div>
              <span className="text-3xl font-black tracking-tight">
                Vicon<span className="text-[#952877]">AI</span>
              </span>
            </div>
            <p className="text-gray-400 mb-8 leading-relaxed font-medium">
              Transforming enterprise architecture with <span className="text-white">bespoke neural solutions</span> and strategic AI excellence.
            </p>
            <div className="flex space-x-3">
              {socialMedia.map(({ Icon, href, label }, index) => (
                <a
                  key={index}
                  target="_blank" 
                  rel="noopener noreferrer"
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:bg-[#952877] hover:text-white hover:-translate-y-1 transition-all duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:pl-8">
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-[#952877] mb-8">Navigation</h3>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 font-bold hover:text-white transition-colors flex items-center group"
                  >
                    <span className="w-0 h-[1.5px] bg-[#952877] mr-0 group-hover:w-4 group-hover:mr-2 transition-all duration-300"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-[#952877] mb-8">Expertise</h3>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index}>
                  <Link 
                    to={service.path} 
                    className="text-gray-400 font-bold hover:text-white transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact - Glass Box */}
          <div className="bg-white/[0.03] backdrop-blur-md p-8 rounded-[2.5rem] border border-white/10">
            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-[#952877] mb-8">Stay Connected</h3>
            <div className="space-y-6">
              <a href="mailto:contact@viconai.com" className="flex items-center space-x-4 group">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-[#952877] group-hover:bg-[#952877] group-hover:text-white transition-all duration-300">
                  <FaEnvelope />
                </div>
                <span className="text-gray-300 font-bold group-hover:text-white transition-colors">contact@viconai.com</span>
              </a>
             
              <div className="flex items-center space-x-4 group">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-[#592aa7]">
                  <FaMapMarkerAlt />
                </div>
                <span className="text-gray-300 font-bold">Noida, U.P, India</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <p className="text-gray-500 text-xs font-bold tracking-widest uppercase">
            &copy; 2026 ViconAI Consultancy. Innovating at scale.
          </p>
          <div className="flex space-x-8">
            <Link to="/privacy" className="text-xs font-black uppercase tracking-widest text-white/30 hover:text-white transition-colors">Privacy</Link>
            {/* <Link to="/terms" className="text-xs font-black uppercase tracking-widest text-white/30 hover:text-white transition-colors">Terms</Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;